import { render } from "./SideBarView.vue?vue&type=template&id=97e2e758"
import script from "./SideBarView.vue?vue&type=script&lang=js"
export * from "./SideBarView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__